module.exports = __webpack_public_path__ + "img/Skirt-Front-B5-Da-Gb-Ha-Ic-Jb.f18e7d23.png";